import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { TranslatePipe } from '../core/i18n/translate.pipe';
import { ApiActivityService } from '../core/services/api-activity.service';

@Component({
  selector: 'app-activity-indicator',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    @if (activity.busy()) {
      <div class="app-loader-bar" aria-hidden="true">
        <span class="app-loader-bar__line"></span>
      </div>

      <div class="app-loader-pill" role="status" aria-live="polite">
        <span class="app-loader-spinner" aria-hidden="true"></span>
        <span>{{ 'shell.loadingData' | t }}</span>
      </div>
    }
  `
})
export class AppActivityIndicatorComponent {
  readonly activity = inject(ApiActivityService);
}
